interface RandomDecision {
  mode: 'random'
  // A number between 0 and 1
  randomWeight?: number
}

interface DeviceDecision {
  mode: 'device'
  device: 'mobile' | 'desktop'
}

type DecisionOptions = RandomDecision | DeviceDecision

export function decision(options: DecisionOptions) {
  const { mode } = options

  if (mode === 'random') {
    const { randomWeight } = options
    const weight = randomWeight || 0.5

    return Math.random() < weight ? 'A' : 'B'
  } else if (mode === 'device') {
    const { device } = options

    return device === 'mobile' ? 'A' : 'B'
  }
}
